module.exports = __webpack_public_path__ + "img/dash-fleet.8670dba6.png";